// 1. FRONTEND VALIDATION HELPER
// Add this to your utils/ folder or directly in MultiSigUI.tsx

// Helper function to validate hexadecimal strings
export const validateHexString = (input: string, fieldName: string = "input"): { isValid: boolean; message?: string } => {
    // Empty string is considered valid (it will use default value)
    if (!input) return { isValid: true };

    // Remove 0x prefix if present
    const value = input.startsWith('0x') ? input.slice(2) : input;

    // Check for valid hex characters
    const hexRegex = /^[0-9a-fA-F]*$/;
    if (!hexRegex.test(value)) {
        return {
            isValid: false,
            message: `${fieldName} contains invalid characters. Only hexadecimal characters (0-9, a-f) are allowed.`
        };
    }

    // Check for even length (required for proper byte encoding)
    if (value.length % 2 !== 0) {
        return {
            isValid: false,
            message: `${fieldName} must have an even number of characters (excluding 0x prefix)`
        };
    }

    return { isValid: true };
};